import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";
import axios from "axios";

export default {
  state: {
    concursos: [],
    concursosLF: [],
    ganhadores: [],
  },
  getters: {
    concursos(state: any) {
      return state.concursos;
    },
    concursosLF(state: any) {
      return state.concursosLF;
    },
    ganhadores(state: any) {
      return state.ganhadores;
    },
  },
  mutations: {
    setConcursos(state: any, concursos: any) {
      state.concursos = concursos;
    },
    setConcursosLF(state: any, concursosLF: any) {
      state.concursosLF = concursosLF;
    },
    setGanhadores(state: any, ganhadores: any) {
      state.ganhadores = ganhadores;
    },
  },
  actions: {
    setConcursosLF({ commit }: { commit: any }, payload: any) {
      commit("setConcursosLF", payload);
    },
    fetchConcursosLF({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/concursoLj/findConcursosLF/" + payload)
          .then((result: any) => {
            commit("setConcursosLF", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    fetchConcursos({ commit }: { commit: any }) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/concursoLj/getConcursos/")
          .then((result: any) => {
            commit("setConcursos", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    fetchGanhadoresConcursos({ commit }: { commit: any }, id: any) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/concursoLj/getGanhadores/"+id)
          .then((result: any) => {
            commit("setGanhadores", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    saveConcurso({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {
        http
          .post("/api/v1/concursoLj/save/", payload)
          .then((result: any) => {
            commit("setProfile", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    removeConcursoLj({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {
        http
          .delete("/api/v1/concursoLj/delete/" + payload)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    fetchConcursosLotoFacil({ commit }: { commit: any }, tipo: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/concurso/"+tipo+"/findLastConcursos")
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    async processarLotoFacil({ commit }: { commit: any }, tipo: any) {
      commit("setLoading", true);
      commit("clearError");
      let url = 'https://servicebus2.caixa.gov.br/portaldeloterias/api/lotofacil/'

    
      return new Promise((resolve, reject) => {
        axios.get('https://servicebus2.caixa.gov.br/portaldeloterias/api/lotofacil/').then((result: any) => {
          
         http
          .post("/api/v1/loterias/processarLoteriaLotofacil", result.data)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
        })
          .catch((err: any) => {
            commit("setError", 'Houve um erro ao co consultar os resultados da loto fácil');
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
       
      });
    }
  },
};
